import React from "react";
import { css } from "emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors, textSizes } from "../../styles/theme";

const InvoiceRow = ({ invoice }) => {
  var date = new Date(0); // The 0 there is the key, which sets the date to the epoch
  date.setUTCSeconds(invoice.created);

  let formattedDate =
    date.getMonth() + 1 + "-" + date.getDate() + "-" + date.getFullYear();

  let amountString = invoice.amount_paid.toString();
  let formattedAmount =
    amountString.length > 1
      ? amountString.slice(0, amountString.length - 2) + "." + amountString.slice(-2)
      : amountString + ".00";
  // console.log(formattedAmount);

  return (
    <div className={container}>
      <p>{invoice.number}</p>
      <p>{formattedDate}</p>
      <div className="align">
        <p>${formattedAmount}</p>
        <div className="spacer"></div>
      </div>
      <a href={invoice.invoice_pdf} className="link">
        <FontAwesomeIcon className="icon" icon="cloud-download-alt" />
      </a>
    </div>
  );
};

export default InvoiceRow;

const container = css`
  margin: 20px 0;
  display: flex;
  align-items: center;
  p {
    flex: 1;
    color: ${colors.subtitleColor};
    font-size: ${textSizes.intermediate};
  }
  .align {
    flex: 1;
    display: flex;
    text-align: right;
    p {
      flex: 1;
    }
    .spacer {
      flex: 3;
    }
  }

  .link {
    flex: 1;
    justify-content: flex-start;
    text-decoration: none;
    .icon {
      color: ${colors.brandColor};
      cursor: pointer;
    }
  }
`;
